var App = App || {};

App.PrestitialAd = (function () {
    const PRESTITIAL_SESSION_KEY = 'scm_prestitial_shown';
    var lastActiveElement = null;

    return {
        init: init,
        resetSessionData: resetSessionData
    };

    function init() {
        if (!shouldShowPrestitialAd()) {
            return;
        }

        loadPrestitialAd();
    }

    function shouldShowPrestitialAd() {
        const prestitialShown = document.cookie.split('; ').find(c => c.startsWith(PRESTITIAL_SESSION_KEY + '='));

        if (prestitialShown) {
            return false;
        }

        if (isMobileDevice()) {
            return false;
        }

        return true;
    }

    function markPrestitialAsShown() {
        document.cookie = PRESTITIAL_SESSION_KEY + '=true; path=/; max-age=86400; SameSite=Lax';
    }


    function isMobileDevice() {
        const mobileBreakpoint = 1023;
        const viewportWidth = SCM.SiteJS?.getViewportWidth?.() || window.innerWidth;

        return viewportWidth <= mobileBreakpoint;
    }

    function loadPrestitialAd() {
        if (typeof gptAdSlots === 'undefined') {
            return;
        }

        if (!gptAdSlots['adPrestitial']) {
            return;
        }

        try {
            refreshGPTSlot(gptAdSlots['adPrestitial']);

            waitForAdToLoad();
        } catch (error) {
            console.error('Prestitial ad: Error loading ad', error);
        }
    }

    function waitForAdToLoad() {
        const $prestitialContainer = $('#adBlockPrestitial');

        if (!$prestitialContainer.length) {
            return;
        }

        SCM.Retry.policy()
                .handleResult(function (result) {
                    return !result;
                })
                .waitAndRetry(30, 100)
                .execute(function () {
                    const hasAdContent = $prestitialContainer.find('iframe[data-load-complete="true"]');

                    if (hasAdContent.length > 0) {
                        return true;
                    }

                    return false;
                })
                .then(function () {
                    showPrestitialModal();
                })
                .catch();
    }

    function showPrestitialModal() {
        const $prestitialModal = $('#prestitialModal');

        if ($prestitialModal.length === 0) {
            return;
        }

        lastActiveElement = document.activeElement;

        markPrestitialAsShown();

        $prestitialModal.removeClass('hide');

        setupModalEventHandlers($prestitialModal);

        document.addEventListener('visibilitychange', handleVisibilityChange);

        if (SCM.trapFocus && SCM.trapFocus.publicTrapFocus) {
            var $closeBtn = $prestitialModal.find('.js-close-prestitial-modal');
            SCM.trapFocus.publicTrapFocus($prestitialModal, $closeBtn, lastActiveElement);
        }

        $prestitialModal.focus();
    }

    function setupModalEventHandlers($modal) {
        $modal.find('.js-close-prestitial-modal').off('click.prestitial');
        $(document).off('keyup.prestitial');
        $modal.off('click.prestitial');

        $modal.find('.js-close-prestitial-modal').on('click.prestitial', function (e) {
            e.preventDefault();
            e.stopPropagation();
            closePrestitialModal();
        });

        $(document).on('keyup.prestitial', function (e) {
            if (e.key === 'Escape') {
                closePrestitialModal();
            }
        });

        $modal.on('click.prestitial', function (e) {
            if (e.target === this) {
                closePrestitialModal();
            }
        });
    }


    function closePrestitialModal() {
        const $prestitialModal = $('#prestitialModal');

        if ($prestitialModal.length) {
            $prestitialModal.addClass('hide');

            $prestitialModal.off('keydown');

            $(document).off('keyup.prestitial');
            $prestitialModal.off('click.prestitial');
            $('.js-close-prestitial-modal').off('click.prestitial');
            document.removeEventListener('visibilitychange', handleVisibilityChange);

            if (lastActiveElement) {
                lastActiveElement.focus();
                lastActiveElement = null;
            }
        }
    }

    function refreshGPTSlot(slot) {
        googletag.cmd.push(function () {
            googletag.pubads().refresh([slot]);
        });
    }

    function handleVisibilityChange() {
        if (document.visibilityState === 'hidden') {
            closePrestitialModal();
        }
    }

    function resetSessionData() {
        document.cookie = PRESTITIAL_SESSION_KEY + '=; path=/; max-age=0; SameSite=Lax';
    }
})();
